export default __webpack_public_path__ + "static/bestie_logo-b26e1427bb11be8dbe8e84444a2cb809.webp";